import * as React from 'react';
import { useEffect, useState } from 'react';

import './ClientSelectInput.scss';
import { Dropdown } from 'react-bootstrap';
import classNames from 'classnames';
import { Input, EInputType } from '@repo/apg-ui';

interface IClientSelectInput {
  values: any;
  onChange: any;
  onInit?: any;
  inputPlaceholder: any;
  inputLabel: any;
  initialValue?: any;
}

export const ClientSelectInput = ({ values, onChange, inputPlaceholder, onInit, initialValue }: IClientSelectInput) => {
  const [filterValue, setFilterValue] = useState('');
  const [filteredValues, setFilteredValues] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (values && values.length) {
      if (initialValue) {
        setSelectedCustomer(initialValue);
        if (initialValue && initialValue.display) {
          setSelectedCustomer(initialValue);
          setFilterValue(initialValue.display);
        }
      }
      setFilteredValues(values);
    }
    if (onInit) {
      onInit();
    }
  }, [values, onInit, initialValue]);

  const filterValues = (filteringValue) => {
    if (!filteringValue) {
      setFilteredValues(values);
    } else {
      let newCustomers = [];
      const lowerCaseFilterValue = filteringValue.toLowerCase();
      for (let customer of values) {
        if (customer.display.toLowerCase().includes(lowerCaseFilterValue)) {
          newCustomers.push(customer);
        }
      }
      if (newCustomers.length === 0) {
        setIsOpen(false);
      }
      setFilteredValues(newCustomers);
    }
  };

  const onCustomerSelect = (customer: { display: React.SetStateAction<string> }) => {
    setSelectedCustomer(customer);
    setFilterValue(customer.display);
    onChange(customer);
    setIsOpen(false);
  };

  return (
    values && (
      <Dropdown
        className='client-search-toggle'
        drop={'down'}
        show={isOpen}
        onToggle={(nextShow, meta) => {
          setIsOpen(nextShow);
        }}
      >
        <Dropdown.Toggle>
          <Input
            inputType={EInputType.Text}
            value={filterValue}
            onChange={(name, value) => {
              setFilterValue(value);
              filterValues(value);
              if (!isOpen && filteredValues.length > 0) setIsOpen(true);
            }}
            placeholder={inputPlaceholder}
            inputWrapperClass='client-select-input-wrapper'
            id='clientSelectInput'
            label='Radius Input'
          />
        </Dropdown.Toggle>

        <Dropdown.Menu className={classNames('dropdown-menu options-wrapper')} renderOnMount={true}>
          {filteredValues.map((value, index) => {
            return (
              <Dropdown.Item
                onClick={() => {
                  onCustomerSelect(value);
                }}
                eventKey={value}
                key={`client-${index}`}
              >
                <div className='client-details-wrapper customRadio'>
                  <div className='client-input-selection'>
                    <input
                      type='radio'
                      name='name-1'
                      value={value?.customerid}
                      onChange={() => {
                        onCustomerSelect(value);
                      }}
                      checked={selectedCustomer?.customerid === value?.customerid}
                    />
                  </div>
                  <div className='client-details'>
                    <div className='client-name'>{value?.display}</div>
                    <div className='client-industry'>
                      <div className='label-value'>
                        {/*<Tooltip*/}
                        {/*    overlayClassName={'rc-tooltip-bg-white'}*/}
                        {/*    placement={'top'}*/}
                        {/*    overlay={*/}
                        {/*        <b>*/}
                        {/*            <FormattedMessage*/}
                        {/*                id="ec.agency.client.industryInfo"*/}
                        {/*                defaultMessage="Industry info tooltip"*/}
                        {/*            />*/}
                        {/*        </b>*/}
                        {/*    }*/}
                        {/*>*/}
                        {/*    <InfoIcon />*/}
                        {/*</Tooltip>*/}
                        <span>{value?.branchelabel}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    )
  );
};
